import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import classnames from 'classnames';
import _find from 'lodash/find';
import PropTypes from 'prop-types';
// Core components
import TableRow from 'components/core/table/TableRow';
import TableCell from 'components/core/table/TableCell';
import Tooltip from 'components/core/Tooltip';
// Models
import mSimcard from 'models/simcard';
// Custom
import { listRowSpecsShape, simcardDataShape, simcardGroupDataShape } from 'constants/PropTypesShapes';
import { showPath } from 'simcards/navigation';
import { formatPhoneNumber } from 'utils/Tools';
import { EditIconButton } from 'components/buttons/IconButtons';
import DeviceWidget from 'devices/assets/main/DeviceWidget';
import AppIcon from 'components/icons/AppIcon';
import TruncatedTooltipText from 'components/misc/TruncatedTooltipText';
import withLoading from 'hocs/WithLoading';

const SimcardGroup = ({ simcard, simcardGroups }) => {
  const simcardGroup = _find(simcardGroups, ['id', simcard.group_id]);
  if (simcardGroup) {
    return (
      <TruncatedTooltipText>{simcardGroup.name}</TruncatedTooltipText>
    );
  }
  return null;
};

SimcardGroup.propTypes = {
  simcard: simcardDataShape.isRequired,
  simcardGroups: PropTypes.arrayOf(simcardGroupDataShape),
};

SimcardGroup.defaultProps = {
  simcardGroups: null,
};

const SimcardStatus = ({ simcard }) => {
  const { labelId, icon, color } = mSimcard.status(simcard);
  return (
    <div className="d-flex align-items-center">
      <Tooltip content={<LocalizedMessage id={labelId} />}>
        <AppIcon color={color} id={icon} />
      </Tooltip>
    </div>
  );
};

SimcardStatus.propTypes = {
  simcard: simcardDataShape.isRequired,
};

const SimcardRow = React.forwardRef(({
  simcard, simcardGroups, countryCode, rowSpecs, handleStartLoading,
}, ref) => {
  const { id: simcardId } = simcard;

  return (
    <TableRow
      ref={ref}
      element={simcard}
      rowSpecs={rowSpecs}
      actions={[
        <EditIconButton key="bEdit" path={showPath(simcardId)} onClick={handleStartLoading} />,
      ]}
    >
      <TableCell className={classnames({ 'table-first-details': rowSpecs.withDetails })}>
        <TruncatedTooltipText>{simcard.iccid}</TruncatedTooltipText>
      </TableCell>
      <TableCell className="hidden-xs-down">
        <TruncatedTooltipText>{formatPhoneNumber(simcard.number, countryCode)}</TruncatedTooltipText>
      </TableCell>
      <TableCell className="table-content-1" noPadding>
        <SimcardStatus simcard={simcard} />
      </TableCell>
      <TableCell className="hidden-md-down">
        <SimcardGroup simcard={simcard} simcardGroups={simcardGroups} />
      </TableCell>
      <TableCell className="table-content-2 hidden-xs-down" noPadding>
        {simcard.device && (
          <div className="d-flex">
            <DeviceWidget
              device={simcard.device}
              parentId={simcardId}
              source="simcard"
              withInstallation
            />
          </div>
        )}
      </TableCell>
    </TableRow>
  );
});

SimcardRow.displayName = 'SimcardRow';

SimcardRow.propTypes = {
  simcard: simcardDataShape.isRequired,
  simcardGroups: PropTypes.arrayOf(simcardGroupDataShape),
  countryCode: PropTypes.string.isRequired,
  rowSpecs: listRowSpecsShape.isRequired,
  handleStartLoading: PropTypes.func.isRequired,
};

SimcardRow.defaultProps = {
  simcardGroups: null,
};

const mapStateToProps = (state) => ({
  simcardGroups: state.simcardGroup.list.elements.data,
  countryCode: state.intl.countryCode,
});

module.exports = compose(
  connect(
    mapStateToProps,
    null,
  ),
  withLoading,
)(SimcardRow);



// WEBPACK FOOTER //
// ./routes/app/routes/simcards/assets/main/SimcardRow.js